// packs

var christmasDiv=document.querySelector('.single_product__christmasbox');
var productColors={
	Playdate:{  colors:["Turquoise","Green","Orange","Purple"] },
	"Mini Playdate":{  colors:["Turquoise","Green","Orange","Purple"] },
	Soother:{  colors:["Turquoise","Green","Orange","Purple"] },
	"Mini Soother":{  colors:["Turquoise","Green","Orange","Purple","Red"] },
	Buddy:{  colors:["Turquoise","Green","Orange","Purple"] },
	"Mini Buddy":{  colors:["Turquoise","Green","Orange","Purple"] },
	Slomo:{  colors:["Turquoise","Green","Orange","Purple","Red"] },
  	"Soother Pro":{  colors:["Turquoise","Green","Orange","Pink","Purple"] },
	"Buddy Tuff":{  colors:["Turquoise","Green","Orange","Red"] },
  	"Soother Tuff":{  colors:["Turquoise","Green","Orange","Purple"] },
  	"Mini Soother Tuff":{  colors:["Turquoise","Green","Orange","Purple"] },
  	"Mini Playdate Tuff":{  colors:["Turquoise","Green","Orange","Purple"] },
  	"Mini Buddy Tuff":{  colors:["Turquoise","Green","Orange","Purple"] },
  	"Playdate Tuff":{  colors:["Turquoise","Green","Orange","Red"] },
  	"Wobble":{  colors:["Turquoise","Green","Orange","Purple"] },
  	"Buddy XL":{  colors:["Turquoise","Green", "Orange"] },
  	"Soother XL":{  colors:["Turquoise","Green", "Orange"] },
  	"Felix":{  colors:["Turquoise","Green", "Orange","Purple","Pink"] },
  	"Casper":{  colors:["Turquoise","Green", "Orange","Purple","Pink"] },
  	"Catster":{  colors:["Turquoise","Green", "Orange","Purple","Pink"] },
  	"Kitty":{  colors:["Turquoise","Green", "Orange","Purple","Pink"] },
	"Cat Playdate":{  colors:["Turquoise","Pink"] },
	"Cat Soother":{  colors:["Turquoise","Pink"] },
	"Cat Buddy":{  colors:["Turquoise","Pink"] },
	"Cat Slomo":{  colors:["Turquoise","Pink","Orange","Green","Purple"] },
	"Cat OH Bowl":{  colors:["Turquoise","Pink"] },
	"UFO":{  colors:["Turquoise","Pink","Green","Orange","Purple"] },
	"Mini Keeper":{  colors:["Orange","Grey","Green","Turquoise","Pink"] },
	"Keeper":{  colors:["Orange","Grey","Green","Turquoise","Pink"] },
	"Indoor Keeper":{  colors:["Orange","Grey","Green","Turquoise","Pink"] },
	"Outdoor Keeper":{  colors:["Orange","Grey","Green","Turquoise","Pink"] },
	"Slodog":{  colors:["Turquoise","Pink","Green","Orange","Black"] },
	"Small Slodog":{  colors:["Turquoise","Pink","Green","Orange","Black"] },
	"Lickoween Playdate":{  colors:["Purple","Orange"] },
	"Lickoween Slomo":{  colors:["Purple","Orange"] },
	"Lickoween Wobble":{  colors:["Purple","Orange"] },
	"Lickoween UFO":{  colors:["Purple","Orange"] },
	"Lickoween Tuff Soother":{  colors:["Purple","Orange"] },
	"Yoggie Pot":{  colors:["Green","Orange","Pink","Turquoise","Purple"] },
	"Splash":{  colors:["Turquoise","Green","Orange"] }
};


var nameDone={};
function appendBundleSelect(table, name) {
	var product=productColors[name];
  	if(!product) {
	  console.log('Cannot find product in bundle',name);
      return;
  	}
	
	if(nameDone[name])
		++nameDone[name];
	else
		nameDone[name]=1;
	var displayName=product.name || name;
    var num=nameDone[name];
    if(num<=1) num='';
	var nameWithNum=name+num;
	var div=document.createElement('tr');
	div.className='christmasbox_dropdown_div';
	var html=
		"<td><label class='christmasbox_dropdown_label'>"+displayName+":</label> </td><td><select name='"+nameWithNum+"'>"+
		"<option>Random Color</option>";
	for(const color of product.colors) {
		html+="<option>"+color+"</option>";
	}
	html+="</select></td>";
	div.innerHTML=html;
  table.appendChild(div);  
}

function appendBundleSelects() {
	var bundleSelects=document.querySelector('.bundleSelects');
    var table = document.createElement('table');
	if(!bundleSelects)
		return;
	var products=bundleSelects.getAttribute('data-bundle').split(',');
	for(var product of products) {
		appendBundleSelect(table, product.trim());
	}
    christmasDiv.appendChild(table);
}

appendBundleSelects();
